<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="validation_label"
    :rules="validation_rules"
  >
    <v-text-field
      v-model="val"
      dense
      :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
      :type="passwordShow ? 'text' : 'password'"
      :disabled="!editable"
      :filled="editable"
      :error-messages="errors"
      :placeholder="placeholder"
      @click:append="passwordShow = !passwordShow"
      @input="$emit('onInput', { name, value: val })"
      :data-testid="testid"
    ></v-text-field>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    values: {
      type: Object,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    validation_rules: {
      type: String,
    },
    validation_label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    testid: {
      type: String,
    },
  },
  data: () => {
    return {
      val: "",
      passwordShow: false,
    };
  },
  mounted() {
    this.$watch(
      () => [this.values, this.name],
      (newValue) => {
        const formValues = newValue[0];
        const name = newValue[1];
        if (formValues && name) this.val = formValues[name];
      },
      { immediate: true, deep: true }
    );
  },
};
</script>
